import { render, staticRenderFns } from "./header.vue?vue&type=template&id=036bed4c&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=036bed4c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bed4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActionPopover: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/ActionPopover/index.vue').default})
